/* eslint-disable react/jsx-curly-spacing */
/* eslint-disable template-curly-spacing */
import React, { Component } from 'react';
import moment from 'moment';
import Table from 'view/component/Table';
import { confirmedAlert } from '../../../view/component/Alert';
import Alert from '../../../view/component/Alert';
import API from 'apiService';
import ModalAdd from './modalAdd';

export default class KegiatanKelompok extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datas: [],
      isLoading: true,
      modalShow: false,
      month: moment().format('YYYY-MM')
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async (e) => {
    const month = e ? moment(e).format('01-MM-YYYY') : '01-08-2015'; //moment().format('01-MM-YYYY');
    const res = await API.get(`registration/prolanis/group/activity/read/${month}`);
    if (res.response) this.setState({ datas: res.response.list, isLoading: false });
    else this.setState({ isLoading: false });
  };

  deleteData = async (id) => {
    const res = await API.delete(`registration/kesling/delete/${id}`);
    if (res.code === 200) {
      Alert('success', 'data dihapus');
      this.getData();
    }
    else Alert('error', 'gagal menghapus data');
  };

  handleMonthChange = (e) => {
    this.setState({ month: e })
    this.getData(e);
  }

  createActionButton = (data) => {
    return (
      <div>
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => this.setState({ data, modalShow: true })}>
          Edit
        </button>
        <button
          className="btn btn-sm btn-outline-danger"
          onClick={() => confirmedAlert(
            'Konfirmasi',
            'Apakah anda akan menghapus data status kesehatan lingkungan?',
            confirmed => {
              if (confirmed) this.deleteData(data.id);
            }
          )}>
          Hapus
        </button>
      </div>
    );
  }

  render() {
    const { datas, isLoading, month, modalShow, data } = this.state;
    return (
      <div>
        <div className="card">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col-8">
                <h4 className="h3 mb-0">Kelompok Kegiatan</h4>
              </div>
              <div className="col-4 text-right">
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  data-toggle="collapse"
                  data-target="#collapsePreview"
                  aria-expanded="false"
                  aria-controls="collapsePreview"
                  onClick={() => this.setState({ modalShow: true })}
                >
                  <span className="btn-inner--text">Tambah Data</span>
                </button>
              </div>
              <div className="col-md-4 mt-2">
                <div className="form-group m-0">
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text text-dark">Bulan</span>
                    </div>
                    <input className="form-control text-dark" type='month' value={month} onChange={(e) => this.handleMonthChange(e.target.value)} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className='row'>
              <div className='col-12'>
                <Table
                  headers={[
                    'No',
                    'Kegiatan',
                    'Kelompok',
                    'tanggal pelayanan',
                    'materi',
                    'pembicara',
                    'lokasi',
                    'biaya',
                    'keterangan',
                    'Aksi',
                  ]}
                  isLoading={isLoading}
                  data={datas}
                  columnMapper={(item) => [
                    item.kegiatan.nama,
                    item.kelompok.nama,
                    item.tglPelayanan,
                    item.materi,
                    item.pembicara,
                    item.lokasi,
                    item.biaya,
                    item.keterangan,
                    this.createActionButton(item),
                  ]}
                  pagination={true}
                />
              </div>
            </div>
          </div>
        </div>
        <ModalAdd
          data={data}
          show={modalShow}
          onHide={() => {
            this.setState({ modalShow: false })
            this.getData();
          }}
        />
      </div>
    );
  }
}
